import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { donorKeys } from '../queries/keys';
import { donorPaths } from '../queries/paths';

// TSS vite/03 — server-state hook for the donor dashboard (cowhousing).
// Endpoint REAL (contract: public-client-channel.md, GET public/donors/:id,
// sobre view:"detail") — NO provisional (decisión 0001 no aplica).
// 404 = donadora no co-poseída / inexistente (anti-enumeración); es un error
// de dominio que maneja el caller, sin side effect global (TSS vite/04).
//
// data: { entity, percent, gross_value, stake_value, production, funnel,
//         rates, offspring, economics, sg_production? } — ver queries/types.js.
//
// ?include (opt-in, aditivos — no cambian el DTO base; tokens desconocidos se
// ignoran server-side):
//  · sg_production (Q-123): data.sg_production = último evento SG por feature
//    (milk/weight/service); el módulo entra a available_modules SOLO si alguna
//    feature trae `last`. No altera data.production (reproductivo).
//  · economics (Q-150, módulo `economic`): enriquece data.economics con la
//    VALORIZACIÓN — purchase_value/purchase_date, current_estimated_value
//    (== gross_value), growth_abs/growth_pct (null-safe si falta valuación).
//    (liquidations_over_time NO se pide acá — el histórico ya lo trae la card
//    de liquidación vía public/liquidations, sin duplicar fuente.)

/**
 * @param {number|string|null|undefined} id
 * @param {{ from?: string, to?: string }} [range] Rango por fecha OPU
 *   (YYYY-MM-DD); from > to → 400 del backend.
 */
export function useClientDonorDetail(id, { from, to } = {}) {
    // from/to entran a la key solo cuando filtran: el dashboard sin rango y el
    // rangeado cachean por separado, y donorKeys.detail(id) invalida ambos.
    const filters = from != null || to != null ? { from, to } : undefined;
    return useQuery({
        queryKey: donorKeys.detail(id, filters),
        queryFn: ({ signal }) =>
            api.get(donorPaths.detail(id), {
                params: { from, to, include: 'sg_production,economics' },
                signal,
            }).then(r => r.data),
        enabled: id != null,
    });
}
